import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { normalizeFaqGroup } from '../config/faqGroups';
import type { FaqItem } from '../types/faq';

export const DEFAULT_FAQ_ITEMS: FaqItem[] = [
  {
    id: 'default-1',
    question: 'Hur fungerar leverans och hämtning?',
    answer: 'Vi levererar och hämtar all utrustning direkt till din festlokal inom Skåne.',
    faq_group: 'leverans',
    sort_order: 1,
  },
  {
    id: 'default-gate',
    question: 'Vad gäller om grinden till lagret är stängd?',
    answer:
      'Du kan fortfarande hämta och återlämna utrustning efter kl. 17 på vardagar och under helger. Grinden till fastigheten är då stängd, så ring oss på 076-677 72 32 när du är på plats så släpper vi in dig. Kontakta oss gärna minst 24 timmar i förväg för att boka tid.',
    faq_group: 'leverans',
    sort_order: 2,
  },
  {
    id: 'default-2',
    question: 'Hur lång tid i förväg behöver jag boka?',
    answer:
      'Vi rekommenderar att du bokar minst 2 veckor i förväg, särskilt under högsäsong (maj-september) och helger. För större event rekommenderar vi att boka minst 1 månad i förväg.',
    faq_group: 'bokning',
    sort_order: 1,
  },
  {
    id: 'default-3',
    question: 'Vilka betalningsmetoder accepterar ni?',
    answer:
      'Vi accepterar alla vanliga betalningsmetoder:\n\n• Visa, Mastercard och American Express\n• Klarna (köp nu, betala senare)\n• Swish\n• Banköverföring\n\nBetalning sker säkert via Stripe efter att din bokning har godkänts. Du får en betalningslänk via e-post.',
    faq_group: 'betalning',
    sort_order: 1,
  },
  {
    id: 'default-4',
    question: 'Vad gäller vid avbokning?',
    answer:
      'Du kan avboka kostnadsfritt upp till 7 dagar före bokningsdatum. Vid avbokning 2–6 dagar innan debiteras 50 %, och vid avbokning senare än 48 timmar före gäller fullt pris.',
    faq_group: 'betalning',
    sort_order: 2,
  },
];

export function useFaqItems() {
  const [items, setItems] = useState<FaqItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchFAQs = async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from('site_content')
          .select('id, title, content, faq_group, sort_order, created_at')
          .eq('category', 'faq')
          .order('sort_order', { ascending: true })
          .order('created_at', { ascending: true });

        if (error) throw error;
        if (cancelled) return;

        setItems(
          (data ?? []).map((row) => ({
            id: row.id,
            question: row.title,
            answer: row.content,
            faq_group: normalizeFaqGroup(row.faq_group),
            sort_order: row.sort_order ?? 0,
          }))
        );
      } catch (err) {
        console.error('Error fetching FAQs:', err);
        if (!cancelled) {
          setItems(DEFAULT_FAQ_ITEMS);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    void fetchFAQs();

    return () => {
      cancelled = true;
    };
  }, []);

  return { items, loading };
}
